import { connect } from 'react-redux';
import './chartLabels.css';
import SliderWithInput from '../SliderWithInput';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Dispatch } from 'redux';
import { updateSankeyStyleOptions } from '../../../redux/ChartPoperties/ChartControlsActions';
import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';
import { textAlign } from 'html2canvas/dist/types/css/property-descriptors/text-align';

export const menuItemStyle = {
  padding: '2px 10px',
  fontSize: '12px',
};

export const SelectComponentStyle = {
  fontSize: '12px',
  width: '96%',
  margin: '0 auto 0.5rem 0.3rem',
  // backgroundColor: 'white',
  height: '1.5rem',

  // color: '#404040',
  textAlign: 'start',
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#2bb9bb', // Set focused border color
  },
};

const SankeyLabelOptions = ({
  // state
  chartControls,
  tabTileProps,

  // dispatch

  updateSankeyStyleOptions,
  iconColor,
  backgroundColor,
}: ChartOptionsProps & {
  updateSankeyStyleOptions: (propKey: string, option: string, value: any) => void;
  iconColor?: string;
  backgroundColor?: string;
}) => {
  var propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  // const handleOnSlide = debounce((value: any) => {
  // 	updateSankeyStyleOptions(propKey, "labelDistance", value);
  // }, 5000);

  const sankeyLabelRotationOption = [
    { name: 'Horizontal', value: 0 },
    { name: 'Vertical', value: 90 },
    { name: 'Vertical Flip', value: -90 },
  ];

  return (
    <div style={{ transform: 'TranslateX(-5px)' }}>
      <div className="optionsInfo" style={{ transform: 'TranslateY(-17px)' }}>
        <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
          Label Position
        </div>
        <FormControl fullWidth size="small" style={{ fontSize: '12px', borderRadius: '4px' }}>
          <Select
            value={chartControls.properties[propKey].sankeyControls.labelPosition}
            variant="outlined"
            onChange={(e) => {
              updateSankeyStyleOptions(propKey, 'labelPosition', e.target.value);
            }}
            sx={{
              ...SelectComponentStyle,
              color: iconColor || '#404040',
              backgroundColor: backgroundColor || 'white',
              '& .MuiSvgIcon-root': { color: iconColor || '#404040' },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: iconColor || '#2bb9bb', // Set focused border color
              },
              '& .MuiSelect-select': {
                color: iconColor || '#404040',
                backgroundColor: backgroundColor || 'white',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: 'rgba(43, 185, 187, 0.1) !important', // Force background color
                  },
                  '& .MuiMenuItem-root.Mui-selected:hover': {
                    backgroundColor: 'rgba(43, 185, 187, 0.2) !important', // Change hover state for selected item
                  },
                },
              },
            }}
          >
            <MenuItem value="inside" key="inside" sx={menuItemStyle}>
              Inside
            </MenuItem>
            <MenuItem value="outside" key="outside" sx={menuItemStyle}>
              Outside
            </MenuItem>
          </Select>
        </FormControl>
        <div style={{ marginTop: '0' }}>
          <div
            className="optionDescription"
            style={{ marginTop: '5px', color: iconColor ? iconColor : '#404040' }}
          >
            Label Distance
          </div>
          <SliderWithInput
            percent={true}
            sliderValue={chartControls.properties[propKey].sankeyControls.labelDistance}
            sliderMinMax={{ min: 0, max: 50, step: 1 }}
            changeValue={(value) => {
              // handleOnSlide(value);
              updateSankeyStyleOptions(propKey, 'labelDistance', value);
            }}
          />
        </div>
        <div
          className="optionDescription"
          style={{ marginTop: '15px', color: iconColor ? iconColor : '#404040' }}
        >
          Label Rotate
        </div>
        <FormControl fullWidth size="small" style={{ fontSize: '12px', borderRadius: '4px' }}>
          <Select
            value={chartControls.properties[propKey].sankeyControls.labelRotate}
            variant="outlined"
            onChange={(e) => {
              updateSankeyStyleOptions(propKey, 'labelRotate', e.target.value);
            }}
            sx={{
              ...SelectComponentStyle,
              color: iconColor || '#404040',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: iconColor || '#2bb9bb', // Set focused border color
              },
              '& .MuiSvgIcon-root': { color: iconColor || '#404040' },
              '& .MuiSelect-select': { color: iconColor || '#404040' },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: 'rgba(43, 185, 187, 0.1) !important', // Force background color
                  },
                  '& .MuiMenuItem-root.Mui-selected:hover': {
                    backgroundColor: 'rgba(43, 185, 187, 0.2) !important', // Change hover state for selected item
                  },
                },
              },
            }}
          >
            {sankeyLabelRotationOption.map((position) => {
              return (
                <MenuItem value={position.value} key={position.name} sx={menuItemStyle}>
                  {position.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <div style={{ marginTop: '0' }}>
          <div
            className="optionDescription"
            style={{ marginTop: '5px', color: iconColor ? iconColor : '#404040' }}
          >
            Label Overflow
          </div>
          <FormControl fullWidth size="small" style={{ fontSize: '12px', borderRadius: '4px' }}>
            <Select
              value={chartControls.properties[propKey].sankeyControls.overFlow}
              variant="outlined"
              onChange={(e) => {
                updateSankeyStyleOptions(propKey, 'overFlow', e.target.value);
              }}
              sx={{
                ...SelectComponentStyle,
                color: iconColor || '#404040',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: iconColor || '#2bb9bb', // Set focused border color
                },
                '& .MuiSvgIcon-root': { color: iconColor || '#404040' },
                '& .MuiSelect-select': { color: iconColor || '#404040' },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root.Mui-selected': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1) !important', // Force background color
                    },
                    '& .MuiMenuItem-root.Mui-selected:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.2) !important', // Change hover state for selected item
                    },
                  },
                },
              }}
            >
              <MenuItem sx={menuItemStyle} value="truncate">
                Truncate
              </MenuItem>
              <MenuItem sx={menuItemStyle} value="break">
                Break
              </MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: ChartOptionsStateProps, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateSankeyStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateSankeyStyleOptions(propKey, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SankeyLabelOptions);
